/*
 * @author: wayou
 * @date: 2018-08-23 12:14:48
 * @description: 加入班级
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IOutput {
    status: number;
}

interface IInput {
    class_id: string;
    type: number;
}

export const joinClassAudited = (param: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.AGREE_JOIN_CLASS, param).then((res: IResponse<IOutput>) => {
        return res;
    });
};
